import { Model, Attribute } from './decorators';
import { BaseApiModel } from './base';
import { WebhookEventType } from '@parashift/shared/types';

export interface EventLog {
  created_at: string;
  event_id: number;
  http_body: string;
  http_status: number;
  updated_at: string;
}

export interface WebhookEventPlainModel {
  id: string;
  attempts: number;
  created_at: string;
  event_type: string;
  failure_reason: string;
  payload: string;
  request_id: string;
  status: string;
  tenant_id: number;
  webhook: string;
  logs: EventLog[];
}

@Model({ type: WebhookEventType })
export class WebhookEvent extends BaseApiModel<WebhookEventPlainModel> {

  @Attribute()
  attempts: number;

  @Attribute()
  created_at: string;

  @Attribute()
  event_type: string;

  @Attribute()
  failure_reason: string;

  @Attribute()
  payload: string;

  @Attribute()
  request_id: string;

  @Attribute()
  status: string;

  @Attribute()
  tenant_id: number;

  @Attribute()
  webhook: string;

  @Attribute()
  logs: EventLog[];

  parseJSON(value: string) {
    value = value.replace(/=>/g, ': ');

    try {
      JSON.parse(value);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return value;
    }

    value = JSON.stringify(JSON.parse(value), undefined, 2);
    return value;
  }

  getPayload() {
    const value = this.payload.replace(/=>/g, ': ');

    try {
      JSON.parse(value);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return value;
    }

    return JSON.parse(value);
  }
}
